import React, { useEffect, useLayoutEffect, useRef, useState, useCallback } from 'react';
import { createMuiTheme, Fab, makeStyles, MuiThemeProvider, Paper, Tab, TableCell, Tabs, TextField, Typography, Snackbar, Badge, Tooltip, withStyles } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from 'mui-datatables';
import AddIcon from '@material-ui/icons/Add';
import CloseImage from '../../assets/ic_close.png';
import icPanggil from '../../assets/ic_call.png';
import icPanggilManual from '../../assets/ic_manualCall.png';
import icCircleBlue from '../../assets/ic_circle_blue.png';
import icCircleGreen from '../../assets/ic_circle_light_green.png';
import IconArrow from '../../assets/ic_arrow.png';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import api from '../api';
import { format } from 'date-fns';
import Loader from 'react-loader-spinner'
import { useLocation, useHistory } from 'react-router-dom';
import { usePrevious } from '../../library/Util';
import MuiAlert from '@material-ui/lab/Alert';
import { PiPProvider, usePiPWindow } from "../components/pip/pip_provider"
import PiPWindow from "../components/pip/pip_window"
import AntrianPIPPage from '../components/antrian/AntrianPIPPage'

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTablePemanggilan());

const options = ct.customOptionsSearch()

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1)
    },
}))

export default function PemanggilanAntrian(props) {
    // const {
    //     isSupported,
    //     requestPipWindow,
    //     pipWindow,
    //     closePipWindow
    //   } = usePiPWindow()

    const location = useLocation();
    const history = useHistory();
    const classes = useStyles()
    
    const [dataAntrian, setDataAntrian] = React.useState([])
    const [dataSkip, setDataSkip] = React.useState([])
    const [statusAntrian, setStatusAntrian] = React.useState("")

    const [dokterScheduleID, setDokterScheduleID] = React.useState("")
    const [dokterScheduleDetailID, setDokterScheduleDetailID] = React.useState("")
    const [loading, setLoading] = React.useState(false)
    const [dataLama, setDataLama] = useState([])
    const [dataLamaSkip, setDataLamaSkip] = useState([])
    const [dataBaru, setDataBaru] = useState([])
    const [dataBaruSkip, setDataBaruSkip] = useState([])
    const prevCount = usePrevious(dataAntrian);
    const prevCountSkip = usePrevious(dataSkip);
    const [totalData, setTotalData] = useState([
        { total: 0 },
        { total: 0 },
    ])

    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [newNotes, setNewNotes] = React.useState("")
    const [visibleStop, setVisibleStop] = React.useState(false)
    const [value, setValue] = React.useState(0);

    const [noAntri, setNoAntri] = React.useState("");
    const [namaPasien, setNamaPasien] = React.useState("")
    const [kodePesanan, setKodePesanan] = React.useState("")
    const [notes, setNotes] = React.useState("")
    const [gender, setGender] = useState("")
    const [visible, setVisible] = React.useState(false)
    const [addCatatan, setAddCatatan] = React.useState(false)
    const [listLokasi] = React.useState([
        { nama: 'Counter A' },
    ])
    const [lokasi, setLokasi] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [rawData, setRawData] = React.useState([])
    const [queueStatus, setQueueStatus] = React.useState("")
    const [called, setCalled] = React.useState("")
    const [disableButton, setDisableButton] = useState(false)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // const {isSupported,requestPipWindow,pipWindow,closePipWindow} = usePiPWindow()

    useEffect(() => {
        if (location.state) {
            props.setShowNotif(false)
            if (dataAntrian.length != (prevCount !== undefined ? prevCount.length : -1)) {
                value === 0 && getDataAntrian()
            }
            if (dataSkip.length != (prevCountSkip !== undefined ? prevCountSkip.length : -1)) {
                value === 1 && getDataSkip()
            }
            const interval = setInterval(() => {
                value === 0 && getData()
                value === 1 && getDataDua()
            }, 10000);
            return () => clearInterval(interval);
        } else {
            history.replace({
                pathname: '/dokter/pemanggilan-dokter',
                name: 'Pemanggilan Dokter',
                state: {  // location state
                },
            })
        }
    }, [dataBaru, dataBaruSkip, value])

    useEffect(() => {
        setLoading(true)
    }, [])


    const getData = () => {
        api.create().getListAntrian(location.state.doctorID, location.state.scheduleID).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.data != null) {
                    if (response.data.data.length > 0) {
                        let a = response.data.data.filter(elm => !dataLama.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
                        if (a.length > 0) {
                            value === 0 && getDataAntrian()
                        }
                    }
                    setDataBaru(response.data.data)
                }
            }
        })
    }

    const getDataDua = () => {
        api.create().getListAntrianSkip(location.state.doctorID, location.state.scheduleID).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.data != null) {
                    if (response.data.data.length > 0) {
                        let a = response.data.data.filter(elm => !dataLamaSkip.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
                        // console.log(a);
                        if (a.length > 0) {
                            value === 1 && getDataSkip()
                        }
                    }
                    setDataBaruSkip(response.data.data)
                }
            }
        })
    }

    const getDataSkip = () => {
        api.create().getListAntrianSkip(location.state.doctorID, location.state.scheduleID).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true && response.data.data != null) {
                    let dataAntrian = response.data.data.map((item, index) => {
                        return [
                            item.queue_number,
                            item.patient_name,
                            item.patient_gender,
                            item.booking_id,
                            item.checkin_at === null ? "" : format(new Date(item.checkin_at), 'dd MMM yyyy HH:mm'),
                            item.queue_status_name,
                            item.is_called,
                            item.patient_id,
                            item.doctor_schedule_id,
                            item.doctor_schedule_detail_id,
                            item.queue_status_id
                        ]
                    })
                    setDataSkip(dataAntrian)
                    setDataLamaSkip(response.data.data)
                    totalData[1].total = response.data.total_data
                    // setTotalData({
                    //     ...totalData,
                    //     skip: response.data.total_data
                    // })
                    if (response.data.data.length > 0) {
                        //     setRawData(response.data.data[0])
                        if (response.data.data[0].is_called === 1 || response.data.data[0].queue_status_id === 2) {
                            let id = response.data.data[0].patient_id
                            let scheduleID = response.data.data[0].doctor_schedule_detail_id
                            getDetailPasienSkip(id, scheduleID)
                        } 
                    } 
                }else{
                    setDataSkip([])
                    setDataLamaSkip([])
                }
                setLoading(false)
            }
        })
    }

    const getDetailPasienSkip = (id, scheduleID) => {
        api.create().getDetailPasienPemanggilan(id, scheduleID).then(res => {
            if (res.data && res.data.data != null) {
                let data = res.data.data
                let a = new Date()
                let year = format(a, 'yyyy-MM-dd')
                let jam = (`${year}T${data.estimated_time}:00+07:00`)
                setNoAntri(data.queue_number)
                setKodePesanan(data.booking_id)
                setNamaPasien(data.patient_name)
                setGender(data.patient_gender)
                setNotes(data.notes)
                setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                setDokterScheduleID(data.doctor_schedule_id)
                setStatusAntrian(data.queue_status_name === "Menunggu" ? "Next" : data.queue_status_name === "Dilewati" || data.queue_status_name === "Ditunda" ? "Next" : data.queue_status_name === "Darurat" || data.queue_status_name === "Dipanggil" ? "Next" : "Proses")
                setQueueStatus(data.queue_status_id)
                setCalled(data.queue_status_name === "Menunggu" || data.queue_status_name === "Dilewati" || data.queue_status_name === "Dipanggil" ? "panggil" : "proses")
                forceUpdate()
            } else {
                setLoading(false)
            }
        })
    }

    const getDataAntrian = () => {
        api.create().getListAntrian(location.state.doctorID, location.state.scheduleID).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true && response.data.data != null) {
                    let dataAntrian = response.data.data.map((item, index) => {
                        return [
                            item.queue_number,
                            item.patient_name,
                            item.patient_gender,
                            item.booking_id,
                            item.checkin_at === null ? "" : format(new Date(item.checkin_at), 'dd MMM yyyy HH:mm'),
                            item.is_called === 1 && (item.queue_status_name === "Darurat" || item.queue_status_name === "Menunggu" || item.queue_status_name === "Ditunda") ? "Dipanggil" : item.is_called === 1 && item.queue_status_name === "Dilayani" ? "Dilayani" : item.queue_status_name === "Dilewati" ? "Dilewati" : item.queue_status_name,
                            item.is_called,
                            item.patient_id,
                            item.doctor_schedule_id,
                            item.doctor_schedule_detail_id,
                            item.queue_status_id
                        ]
                    })
                    let idxDisable = response.data.data.findIndex((val) => val.queue_status_id === 2)
                    if (idxDisable > -1) {
                        setDisableButton(true)
                    }
                    if (response.data.data.length > 0) {
                        //     setRawData(response.data.data[0])
                        if (response.data.data[0].is_called === 1 || response.data.data[0].queue_status_id === 2) {
                            let id = response.data.data[0].patient_id
                            let scheduleID = response.data.data[0].doctor_schedule_detail_id
                            getDetailPasien(id, scheduleID)
                        }
                    }
                    setDataAntrian(dataAntrian)
                    setDataLama(response.data.data)
                    totalData[0].total = response.data.total_data
                }else{
                    setDataAntrian([])
                    setDataLama([])
                }
                setLoading(false)
            }
        })
    }

    const getDetailPasien = (id, scheduleID) => {
        api.create().getDetailPasienPemanggilan(id, scheduleID).then(res => {
            if (res.data && res.data.data != null) {
                console.log(res);
                let data = res.data.data
                setNoAntri(data.queue_number)
                setKodePesanan(data.booking_id)
                setNamaPasien(data.patient_name)
                setNotes(data.notes)
                setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                setDokterScheduleID(data.doctor_schedule_id)
                setStatusAntrian(data.queue_status_name === "Menunggu" ? "Next" : data.queue_status_name === "Dilewati" || data.queue_status_name === "Ditunda" ? "Next" : data.queue_status_name === "Darurat" || data.queue_status_name === "Dipanggil" ? "Next" : "Proses")
                setQueueStatus(data.queue_status_id)
                setCalled(data.queue_status_name === "Menunggu" || data.queue_status_name === "Dilewati" || data.queue_status_name === "Dipanggil" ? "panggil" : "proses")
                setLoading(false)
                forceUpdate()
            } else {
                setLoading(false)
            }
        })
    }

    const handleNextPatient = () => {
        setLoading(true)
        // if (rawData.queue_status_name === "New") {
        let payload = {
            "doctor_schedule_id": location.state.scheduleID,
            "doctor_schedule_detail_id": null,
            "status": "NEXT"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data === true) {
                        getDataAntrian()
                        alert('Antrian tidak tersedia')
                    } else {
                        getDataAntrian()
                        let data = response.data.data
                        setNoAntri(data.queue_number)
                        setKodePesanan(data.booking_id)
                        setNamaPasien(data.patient_name)
                        setNotes(data.notes)
                        setQueueStatus(data.queue_status_id)
                        setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                        setDokterScheduleID(data.doctor_schedule_id)
                        setStatusAntrian("Next")
                        forceUpdate()
                    }
                } else {
                    if (response.data) {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("warning")
                        }
                        // if (response.data.data === "Sesi dokter harus dimulai terlebih dahulu!") {
                        //     alert('Sesi dokter belum dimulai')
                        // }
                    }
                    setLoading(false)
                }
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleStart = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "new_notes": newNotes,
            "status": "START"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setTimeout(() => {
                        getDataAntrian()
                        getDataSkip()
                    }, 300);
                    setStatusAntrian("Proses")
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleStop = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "new_notes": newNotes,
            "status": "DONE"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setStatusAntrian("")
                    setNewNotes("")
                    setNoAntri("")
                    setKodePesanan("")
                    setCalled("")
                    setNamaPasien("")
                    setNotes("")
                    getDataAntrian()
                    setVisibleStop(false)
                    getDataSkip()
                    setDisableButton(false)
                    props.setSelectNotification(null)
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleSkip = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "status": "SKIP"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setStatusAntrian("")
                    setNoAntri("")
                    setKodePesanan("")
                    setNamaPasien("")
                    setNotes("")
                    setCalled("")
                    getDataAntrian()
                    getDataSkip()
                    setDisableButton(false)
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleCall = ({ rowData }) => {
        setLoading(true)
        console.log(rowData);
        let payload = {
            "doctor_schedule_id": rowData[8],
            "doctor_schedule_detail_id": rowData[9],
            "status": "CALL"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setNoAntri(data.queue_number)
                    setKodePesanan(data.booking_id)
                    setNamaPasien(data.patient_name)
                    setNotes(data.notes)
                    setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                    setDokterScheduleID(data.doctor_schedule_id)
                    setStatusAntrian("Next")
                    getDataSkip()
                    getDataAntrian()
                    // forceUpdate()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleCallManual = ({ rowData }) => {
        setLoading(true)
        console.log(rowData);
        let payload = {
            "doctor_schedule_id": rowData[8],
            "doctor_schedule_detail_id": rowData[9],
            "status": "CALL",
            "without_call": 1
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setNoAntri(data.queue_number)
                    setKodePesanan(data.booking_id)
                    setNamaPasien(data.patient_name)
                    setNotes(data.notes)
                    setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                    setDokterScheduleID(data.doctor_schedule_id)
                    setStatusAntrian("Next")
                    getDataSkip()
                    getDataAntrian()
                    // forceUpdate()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleCallSkip = ({ rowData }) => {
        setLoading(true)
        console.log(rowData);
        let payload = {
            "doctor_schedule_id": rowData[9],
            "doctor_schedule_detail_id": rowData[10],
            "status": "CALL"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setNoAntri(data.queue_number)
                    setKodePesanan(data.booking_id)
                    setNamaPasien(data.patient_name)
                    setNotes(data.notes)
                    setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                    setDokterScheduleID(data.doctor_schedule_id)
                    setStatusAntrian("Next")
                    getDataSkip()
                    getDataAntrian()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleCallSkipManual = ({ rowData }) => {
        setLoading(true)
        console.log(rowData);
        let payload = {
            "doctor_schedule_id": rowData[9],
            "doctor_schedule_detail_id": rowData[10],
            "status": "CALL",
            "without_call": 1
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setNoAntri(data.queue_number)
                    setKodePesanan(data.booking_id)
                    setNamaPasien(data.patient_name)
                    setNotes(data.notes)
                    setDokterScheduleDetailID(data.doctor_schedule_detail_id)
                    setDokterScheduleID(data.doctor_schedule_id)
                    setStatusAntrian("Next")
                    getDataSkip()
                    getDataAntrian()
                } else {
                    if (response.data.data === "Sesi dokter harus dimulai terlebih dahulu!") {
                        alert('Sesi dokter belum dimulai')
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleHold = () => {
        setLoading(true)
        let payload = {
            "doctor_schedule_id": dokterScheduleID,
            "doctor_schedule_detail_id": dokterScheduleDetailID,
            "new_notes": newNotes,
            "status": "HOLD"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    props.setSelectNotification(null)
                    setStatusAntrian("")
                    setNoAntri("")
                    setKodePesanan("")
                    setNamaPasien("")
                    setCalled("")
                    setNotes("")
                    getDataAntrian()
                    getDataSkip()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                    setLoading(false)
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    const columns = [
        {
            name: "No. Antrian",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Nama Pasien",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Jenis Kelamin",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "ID Reservasi",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Check In",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Status",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[6] === 1) ?
                                <LightTooltip title={"Panggil"} arrow>
                                    <div
                                        onClick={() => statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[6] === 1) ? handleCall(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleGreen})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 10, cursor: 'pointer' }}>
                                        <img src={icPanggil} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                            {statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[6] === 1) ?
                                <LightTooltip title={"Panggil Manual"} arrow>
                                    <div
                                        onClick={() => statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[6] === 1) ? handleCallManual(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleBlue})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                        <img src={icPanggilManual} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }];

    const columnsSkip = [
        {
            name: "No. Antrian",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Nama Pasien",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Jenis Kelamin",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "ID Reservasi",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Check In",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        }, {
            name: "Status",
            options: {
                sort: true,
                filter: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography style={{ fontSize: 13, color: tableMeta.rowData[6] === 1 || tableMeta.rowData[10] === 2 ? 'red' : 'black' }}>{val}</Typography>
                        </div>
                    )
                }
            }
        },
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{}}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    // console.log(tableMeta);
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[6] === 1) ?
                                <LightTooltip title={"Panggil"} arrow>
                                    <div
                                        onClick={() => statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[6] === 1) ? handleCall(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleGreen})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 10, cursor: 'pointer' }}>
                                        <img src={icPanggil} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                            {statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[6] === 1) ?
                                <LightTooltip title={"Panggil Manual"} arrow>
                                    <div
                                        onClick={() => statusAntrian === "" || (statusAntrian === "Next" && tableMeta.rowData[7] === 1) ? handleCallManual(tableMeta) : null}
                                        style={{ backgroundImage: `url(${icCircleBlue})`, width: 37, height: 37, backgroundRepeat: 'round', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                        <img src={icPanggilManual} style={{ width: 20, height: 20 }} />
                                    </div>
                                </LightTooltip>
                                : null
                            }
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',

    };

    return (
        <div>
            {loading && (loadingComponent)}
            <Paper style={{ boxShadow: 'none' }} >
                <div style={{ width: '100%', display: 'grid' }}>
                    <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity={statusAlert}>
                            {messageAlert}
                        </Alert>
                    </Snackbar>
                </div>
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="#2a9c6c"
                    onChange={handleChange}
                    aria-label="disabled tabs example"
                    style={{ outline: 'null' }}
                    classes={{ indicator: classes.tabsIndicator }}
                >
                    <Tab
                        label={<Badge badgeContent={totalData[0].total} color="primary">
                            List Antrian
                        </Badge>} style={{ color: value === 0 ? '#2a9c6c' : 'black' }} />
                    <Tab label={<Badge badgeContent={totalData[1].total} color="primary">
                        List Antrian Terlewat
                    </Badge>} style={{ color: value === 1 ? '#2a9c6c' : 'black' }} />
                </Tabs>
            </Paper>
            {value === 0 ?
                <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
                    <div style={{ display: 'flex' }}>
                        {statusAntrian === "" ?
                            <button
                                style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#0094FF', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                onClick={() => handleNextPatient()}
                            >
                                <Typography style={{ color: 'white' }}>Antrian Selanjutnya</Typography>
                            </button>
                            : statusAntrian === "Next" ?
                                <div style={{ display: 'flex' }}>
                                    <button
                                        style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#4CDC63', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                        onClick={() => handleStart()}
                                    >
                                        <Typography style={{ color: 'white' }}>Start</Typography>
                                    </button>
                                    <button
                                        style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#EDD60A', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                        onClick={() => handleSkip()}
                                    >
                                        <Typography style={{ color: 'white' }}>Lewati</Typography>
                                    </button>
                                </div>
                                : statusAntrian === "Proses" ?
                                    <div style={{ display: 'flex' }}>
                                        <button
                                            style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#FFA654', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                            onClick={() => handleHold()}
                                        >
                                            <Typography style={{ color: 'white' }}>Hold</Typography>
                                        </button>
                                        <button
                                            style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#FF5B5B', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                            onClick={() => setVisibleStop(true)}
                                        >
                                            <Typography style={{ color: 'white' }}>Stop</Typography>
                                        </button>
                                    </div>
                                    : null
                        }
                        {/* <div style={{ position: 'absolute', right: 55, }}>
                            <button
                                style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#0094FF', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10, alignItems:'flex-end', float:'right' }}
                                onClick={() => handleNextPatient()}
                            >
                                <Typography style={{ color: 'white' }}>Open PIP</Typography>
                            </button>
                        </div> */}
                    </div>

                    {!loading && (
                        <MuiThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                                data={dataAntrian}
                                columns={columns}
                                options={options}
                            />
                        </MuiThemeProvider>
                    )}
                </Paper>
                :
                <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', marginTop: 20, padding: 10, zIndex: 2 }} >
                    {statusAntrian === "" ?
                        // <button
                        //     style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#0094FF', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                        //     onClick={() => handleNextPatient()}
                        // >
                        //     <Typography style={{ color: 'white' }}>Antrian Selanjutnya</Typography>
                        // </button>
                        null
                        : statusAntrian === "Next" ?
                            <div style={{ display: 'flex' }}>
                                <button
                                    style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#4CDC63', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                    onClick={() => handleStart()}
                                >
                                    <Typography style={{ color: 'white' }}>Start</Typography>
                                </button>
                                <button
                                    style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#EDD60A', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                    onClick={() => handleSkip()}
                                >
                                    <Typography style={{ color: 'white' }}>Lewati</Typography>
                                </button>
                            </div>
                            : statusAntrian === "Proses" ?
                                <div style={{ display: 'flex' }}>
                                    <button
                                        style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#FFA654', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                        onClick={() => handleHold()}
                                    >
                                        <Typography style={{ color: 'white' }}>Hold</Typography>
                                    </button>
                                    <button
                                        style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#FF5B5B', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                        onClick={() => setVisibleStop(true)}
                                    >
                                        <Typography style={{ color: 'white' }}>Stop</Typography>
                                    </button>
                                </div>
                                : null
                    }
                    {!loading && (
                        <MuiThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                                data={dataSkip}
                                columns={columnsSkip}
                                options={options}
                            />
                        </MuiThemeProvider>
                    )}
                </Paper>
            }

            {visibleStop && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleStop(false)
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <div style={{ height: '30vh' }}>
                            <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 30 }}>Catatan Baru</Typography>
                            <textarea
                                label="Catatan Petugas"
                                value={newNotes}
                                onChange={(e) => {
                                    setNewNotes(e.target.value)
                                }}
                                style={{ width: '70%', marginTop: 10, height: '15vh' }}
                                placeholder={"input catatan baru"}
                            />
                            <Typography style={{ fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa diubah</Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%' }}>
                                <div
                                    onClick={() => handleStop()}
                                    style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
